import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Link, useLocation, useParams } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { Subtract } from '../../../assets/images/web-isn';
import { getLanguage, getPathLanguage, getQueryString } from '../../../utils/params';
// import { isMobile } from '../../../utils/constants';
import { getBlog } from '../blogs.api';

function Breadcrumb() {
  const { t } = useTranslation();
  const location = useLocation();
  const language = getLanguage(useLocation());
  const pathLanguage = getPathLanguage(location);
  // const getHref = window.location.href;
  const { category, slug, id } = useParams();
  const searchParams = new URLSearchParams(useLocation().search);
  const [blog, setBlog] = useState();

  useEffect(() => {
    if (slug) {
      getBlog(getQueryString({ language, id })).then(
        res => {
          if (res) {
            setBlog(res)
          }
        });
    }
  }, [slug, language, id]);

  let textCategory = '';
  let idCategory = '';
  switch (category) {
    case 'news':
      textCategory = t('blogs.news')
      idCategory = 2
      break;
    case 'newly-launched-properties':
      textCategory = t('blogs.newly_launched_properties')
      idCategory = 3
      break;
    case 'rental-living-tips':
      textCategory = t('blogs.rental_living_tips');
      idCategory = 4
      break;
    case 'living-in-vietnam':
      textCategory = t('blogs.living_in_vietnam');
      idCategory = 5
      break;
    default:
      textCategory = t('blogs.all_blogs')
  }

  return (
    <div id="breadcrumbApartmentMenu">
      <div className="container">
        <div className="apartment-breadcrumb">
          <ul className="d-flex align-items-center">
            <li className="first-item mr-3">
              <Link className="home mr-3" to={pathLanguage}>
                {t('blogs.home')}
              </Link>
              <img src={Subtract} alt="subtract" />
            </li>
            {searchParams.get('home') !== 'true' ? (
              <li className="item">
                {slug && category ? (
                  <><Link className=" child-item-no-link mr-3" to={`${pathLanguage}/blogs/${category}${idCategory ? '/' + idCategory : ''}/?pageIndex=1`}>
                    {textCategory}
                  </Link><img src={Subtract} alt="subtract" /></>
                ) : (
                  <span className="child-item-no-link mr-3 child-active"> {textCategory}</span>
                )}
              </li>) : ''}
            {slug ? (
              <li className="item ">
                {/* <img className="mb-1" src={Subtract} alt="subtract" /> */}
                <span className="ml-3 breadcrum-mt-2px  breadcrum-mt-3px  child-active text-truncate-breadcrumb-name"> {blog && blog.title}</span>
              </li>)
              : ''}
          </ul>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = state => ({
  ...state,
});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Breadcrumb);
